export default function MySQL_CONCAT() {
  return (
    <div>
      <h2>MySQL_CONCAT</h2>    </div>
  );
}